import { ChangeEvent, useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Card, Row } from 'components'
import { useModal, usePersistForm } from 'hooks'
import useAuth from 'hooks/useAuth'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import { NovoUsuarioForm } from 'pages/Supplier/Users/components/ModalNewUser/ModalNewUser'
import { TypeHandleUser } from 'pages/Supplier/Users/Users'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation } from 'react-router'
import { UserSupplierServices, UserServices, ISupplierGetAllParams } from 'services/Supplier/Users'
import { COLORS, FORMAT, SPACING, OLDYUP as YUP } from 'utils'
import { createArrayCopy } from 'utils/functions'
import { TypesStatus, UsuarioFornecedor } from 'utils/types'
import * as Yup from 'yup'

import { TableAccess, Filters, ModalEditUser } from './components'

export interface ITableContent {
  selected: boolean | null
  content: UsuarioFornecedor
}

interface FiltersForm {
  nmUsuario: string
  nmFornecedor: string
  cdDocto: number | string
  cdDoctoFornecedor: number | string
  flSituacao: TypesStatus
  dtAcessoInicio: Date
  dtAcessoFim: Date
  txEmail: string
}

const DEFAULT_FORM: FiltersForm = {
  cdDocto: undefined,
  cdDoctoFornecedor: undefined,
  dtAcessoFim: null,
  dtAcessoInicio: null,
  flSituacao: 'p',
  nmFornecedor: undefined,
  nmUsuario: undefined,
  txEmail: undefined
}

const ValidationAccess = () => {
  const { showModal } = useModal()
  const { setLoading, setMsgErro } = useLoading()
  const { user, TipoUsuario } = useAuth()
  const { push } = useHistory()
  const location = useLocation()
  const [liberarAlerta, toggleLiberarAlerta] = useToggle()
  const [bloquiarAlerta, toggleBloquiarAlerta] = useToggle()
  const [openEditModal, toggleEditModal] = useToggle()

  const schema = Yup.object().concat(
    YUP.dateRange('dtAcessoInicio', 'dtAcessoFim').oneRequireAnother
  )

  const {
    control,
    reset,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm<FiltersForm>({
    defaultValues: DEFAULT_FORM,
    resolver: yupResolver(schema)
  })

  usePersistForm('search-validation-acess-form', {
    setValue: setValue,
    watch: watch
  })

  const [listUsers, setListUsers] = useState<ITableContent[] | undefined>()
  const [, setListUsersFixed] = useState<ITableContent[] | undefined>()

  const [userSelected, setUser] = useState<UsuarioFornecedor | undefined>()
  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [pageCount, setPageCount] = useState<number>(1)
  const IsGST = TipoUsuario == 'GST' ? true : false
  
  const getAllUsers = (dataObj: FiltersForm) => {
    setLoading('loading')

    UserSupplierServices()
      .getAll({
        IsGST: IsGST,
        ...(![null, 'none'].includes(dataObj.flSituacao) && { Status:  dataObj.flSituacao }),
        ...(dataObj.cdDoctoFornecedor && { CPFCNPJPASSAPORT: String(dataObj.cdDoctoFornecedor).replace(
            /[^0-9a-zA-Z]/g,
            ''
          )}),
        ...(dataObj.cdDocto && {CPFPASSAPORTE: String(dataObj.cdDocto).replace(/[^0-9a-zA-Z]/g, '')}),
        ...(dataObj.nmUsuario && {NmColaborador: dataObj.nmUsuario}),
        ...(dataObj.nmFornecedor && {NmFornecedor: dataObj.nmFornecedor}),
        ...(dataObj.txEmail && {txEmail: dataObj.txEmail}),
        PageNumber: page,
        PageSize: rowsPerPage,
        ...(dataObj.dtAcessoFim && {ValidadeAcessoFim: moment(dataObj.dtAcessoFim).toISOString()}),
       ...(dataObj.dtAcessoInicio && { ValidadeAcessoInicio: moment(dataObj.dtAcessoInicio).toISOString()})
      })
      .then((response) => {
        if (response.status === 200) {
          const temp = []

          response.data?.items.forEach((el) => {
            let select = false
            if (el.flSituacao === 'D') {
              select = null
            }
            temp.push({
              content: el,
              selected: select
            })
          })
          setPageCount(response.data.pageCount)
          setListUsers(temp)
          setListUsersFixed(temp)
        }

        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.toString(),
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    const cpy = createArrayCopy(listUsers)
    setListUsers(
      cpy.map((el) => {
        if (el.selected != null) {
          return { ...el, selected: e.target.checked }
        }
        return el
      })
    )
  }

  const handleUpdateCheckBox = (usuarioId: number) => {
    const cpy = createArrayCopy(listUsers)
    const index = cpy.findIndex((el) => el.content.usuarioId === usuarioId)
    cpy[index].selected = !cpy[index].selected
    setListUsers(cpy)
  }

  const handleDisabledUser = async (user: UsuarioFornecedor) => {
    //SE O USUARIO FOR FL SITUACAO "P" -> "D"
    //SE O USUARIO FOR FL SITUACAO "D" -> "P"
    setLoading('loading')

    try {
      let newSituacao

      if (user.flSituacao === 'D') {
        newSituacao = 'P'
      } else {
        newSituacao = 'D'
      }

      const response = await UserServices().updateFlSituacao({
        flSituacao: newSituacao,
        idUsuario: user.usuario.idUsuario
      })

      if (response.status !== 200) {
        if (newSituacao === 'P')
          throw new Error('Erro ao deixar pendente o usuario.')
        if (newSituacao === 'D') throw new Error('Erro ao desativar usuario.')
      }

      const cpyArr = createArrayCopy(listUsers)
      const index = cpyArr.findIndex(
        (el) => el.content.idUsuarioFornecedor === user.idUsuarioFornecedor
      )

      if (newSituacao === 'D') {
        cpyArr[index].selected = null
      } else {
        cpyArr[index].selected = false
      }

      cpyArr[index].content.flSituacao = newSituacao
      setListUsers(cpyArr)
      setLoading('idle')
      setUser(null)
    } catch (error: any) {
      setMsgErro(error.toString())
      setLoading('error')
    }
  }

  const handleDesBlockUser = async () => {
    setLoading('loading')

    try {
      const { data } = await UserServices().updateFlSituacao({
        flSituacao: 'L',
        idUsuario: userSelected.usuario.idUsuario
      })

      if (!data.sucesso) throw new Error('Erro atualizar dados')

      getAllUsers(getValues())
      setLoading('idle')
      setUser(null)
    } catch (error: any) {
      setMsgErro(error.toString())
      setLoading('error')
    }
  }

  const handleEditUser = async (requestData: NovoUsuarioForm) => {
    setLoading('loading')

    try {
      const { data } = await UserServices().put([
        {
          cdDocto: FORMAT.unMask(requestData.cdDocto),
          idUsuario: userSelected.usuario.idUsuario,
          nmUsuario: requestData.nmUsuario,
          nuContato: FORMAT.unMask(requestData.nuContato),
          nuRamal: userSelected.usuario.nuRamal,
          perfilUsuarioId: requestData.perfilUsuarioId,
          txEmail: requestData.txEmail,
          usuarioFornecedor: {
            flSituacao: userSelected.flSituacao,
            idUsuarioFornecedor: userSelected.idUsuarioFornecedor
          }
        }
      ])
      if (!data.sucesso) throw new Error('Erro atualizar dados')
      getAllUsers(getValues())
      setUser(null)
      toggleEditModal()
      showModal({
        hideButtonCancel: true,
        message: 'Usuário editado com sucesso.',
        txtButtonConfirm: 'ok',
        type: 'success'
      })
      setLoading('idle')
    } catch (error: any) {
      showModal({
        hideButtonCancel: true,
        message: 'Ocorreu um erro e não foi possível editar o usuário',
        txtButtonConfirm: 'ok',
        type: 'error'
      })
      toggleEditModal()
      setMsgErro(error.toString())
      setLoading('error')
    }
  }

  const handleSelectUser = (user: UsuarioFornecedor, type: TypeHandleUser) => {
    setUser(user)
    if (type === 'edit') {
      toggleEditModal()
      return
    }
    if (type === 'block') {
      showModal({
        handleConfirm: () => handleDisabledUser(user),
        message: `Deseja ${user?.flSituacao === 'D' ? 'reativar' : 'desativar'
          } o usuario ${user?.usuario?.nmUsuario}?`,
        titleModal: 'Atenção',
        type: 'alert'
      })
      return
    }
    if (type === 'desblock') {
      handleDesBlockUser()
      return
    }
    if (type === 'contract') {
      push({
        pathname: '/contratos-usuario/',
        state: {
          idUsuarioFornecedor: user.idUsuarioFornecedor,
          isValidateAcess: true
        }
      })
      return
    }
  }

  const handleUpdateUser = async (action: 'L' | 'B' | 'D') => {
    const url = window.location.href
    bloquiarAlerta === true && toggleBloquiarAlerta()
    liberarAlerta === true && toggleLiberarAlerta()

    setLoading('loading')
    try {
      const listEnvio: number[] = []
      listUsers.forEach((el) => {
        if (el.selected && el.content.flSituacao != action) {
          listEnvio.push(el.content.usuarioId)
        }
      })
      const response = await UserServices().validate({
        flSituacao: action,
        listaIdsAprovacao: listEnvio,
        nomeAnalista: user.NmUsuario,
        urlRedirecionamento: url.replace(location.pathname, '')
      })

      if (!response.data.sucesso)
        throw new Error('Não foi possivel executar essa ação')
      reset()
      getAllUsers(getValues())
      showModal({
        hideButtonCancel: true,
        message:
          action === 'L'
            ? 'Usuario(s) foram validados'
            : 'Usuario(s) foram recusados',
        titleModal: 'Sucesso',
        txtButtonConfirm: 'Fechar',
        type: 'success'
      })
      setLoading('idle')
    } catch (error: any) {
      error?.mensagem && setMsgErro(error.mensagem)
      error?.result && setMsgErro(error.result.detail, error.result.title)
      setLoading('error')
    }
  }

  const handleSearch = (form: FiltersForm) => {
    setLoading('loading')
    setPage(1)

    UserSupplierServices()
      .getAll({
        IsGST: IsGST,
        PageNumber: 1,
        PageSize: rowsPerPage,
        ...(![null, 'none'].includes(form.flSituacao.toLowerCase()) && {
          Status: form.flSituacao
        }),
        ...(form.nmFornecedor && { NmFornecedor: form.nmFornecedor }),
        ...(form.cdDocto && {
          CPFPASSAPORTE: String(form.cdDocto).replace(/[^0-9a-zA-Z]/g, '')
        }),
        ...(form.nmUsuario && { NmColaborador: form.nmUsuario }),
        ...(form.cdDoctoFornecedor && {
          CPFCNPJPASSAPORT: String(form.cdDoctoFornecedor).replace(
            /[^0-9a-zA-Z]/g,
            ''
          )
        }),
        ...(form.dtAcessoFim && {
          ValidadeAcessoFim: moment(form.dtAcessoFim).toISOString()
        }),
        ...(form.txEmail && {
          txEmail: form.txEmail.trim()
        }),
        ...(form.dtAcessoInicio && {
          ValidadeAcessoInicio: moment(form.dtAcessoInicio).toISOString()
        })
      })
      .then((response) => {
        if (response.status === 200) {
          const temp = []

          response.data?.items.forEach((el) => {
            let select = false
            if (el.flSituacao === 'D') {
              select = null
            }
            temp.push({
              content: el,
              selected: select
            })
          })
          setPageCount(response.data.pageCount)
          setListUsers(temp)
          setListUsersFixed(temp)
        }

        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.toString(),
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const resetFilter = () => {
    setLoading('loading')
    reset()
    setPage(1)

    UserSupplierServices()
      .getAll({
        IsGST: IsGST,
        PageNumber: 1,
        PageSize: rowsPerPage,
        Status: getValues('flSituacao')
      })
      .then((response) => {
        if (response.status === 200) {
          const temp = []

          response.data?.items.forEach((el) => {
            let select = false
            if (el.flSituacao === 'D') {
              select = null
            }
            temp.push({
              content: el,
              selected: select
            })
          })
          setPageCount(response.data.pageCount)
          setListUsers(temp)
          setListUsersFixed(temp)
        }

        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.toString(),
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleDisableBtn = listUsers?.some((el) => el.selected === true)

  const handleShowUserSuppliers = (usuarioId: number) => {
    setListUsers((prevState) =>
      prevState.map((user) => ({
        ...user,
        content: {
          ...user.content,
          isShowSuppliers:
            usuarioId === user.content.usuarioId &&
            !user.content.isShowSuppliers
        }
      }))
    )
  }

  useEffect(() => {
    getAllUsers(getValues())
  }, [page, rowsPerPage])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginTop={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Filters
          handleReset={resetFilter}
          control={control}
          watch={watch}
          errors={errors}
          onSubmit={handleSubmit(handleSearch)}
        />
        <TableAccess
          tableData={listUsers}
          pageCount={pageCount}
          handleShowUserSuppliers={handleShowUserSuppliers}
          page={page}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          handleSelectAll={handleSelectAll}
          handleUpdateCheckBox={handleUpdateCheckBox}
          setSelectedUser={handleSelectUser}
        />
        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button
            text="Recusar"
            variantButton="text"
            onClick={() => {
              showModal({
                handleConfirm: () => handleUpdateUser('D'),
                message:
                  'Você realmente deseja recusar o acesso desse(s) colaborador(es)?',
                titleModal: 'Atenção',
                type: 'alert'
              })
            }}
            marginRight={SPACING.spacing20}
            disabled={!handleDisableBtn}
          />
          <Button
            text="Validar"
            onClick={() =>
              showModal({
                handleConfirm: () => handleUpdateUser('L'),
                message:
                  'Você realmente deseja validar o acesso desse(s) colaboradore(s)?',
                titleModal: 'Atenção',
                type: 'alert'
              })
            }
            disabled={!handleDisableBtn}
          />
        </Row>
        <Row
          justifyContent="flex-start"
          marginTop={SPACING.spacing10}
          marginBottom={SPACING.spacing5}
        >
          <Button
            text="RELATÓRIO DE ACESSO"
            onClick={() => push('/ngt/relatorios-acesso')}
          />
        </Row>
      </Card>
      {!!openEditModal && (
        <ModalEditUser
          showModal={openEditModal}
          toggleModal={toggleEditModal}
          userData={userSelected}
          onSubmit={handleEditUser}
        />
      )}
    </>
  )
}

export default ValidationAccess
